import portalWrapper from '@/components/app/portalWrapper'
import store from '@/store'

const routes = [
  {
    path      : '*/scheduling/weekschedule',
    name      : 'viewSchedules',
    component : portalWrapper,
    props     : {
      view     : 'scheduling/index',
      portalId : 'scheduling-index'
    }
  },
  {
    path      : '*/scheduling/hotfloor',
    name      : 'HotFloor',
    component : portalWrapper,
    props     : {
      view      : 'scheduling/hotfloor/index',
      portalId  : 'hot-floor-view',
      namespace : 'hotfloor'
    }
  },
  {
    path      : '*/dashboard/my',
    name      : 'myDashboard',
    component : () => import('@/views/dashboard/index')
  },
  {
    path      : '*/dashboard/analytics',
    name      : 'analyticsDashboard',
    component : () => import('@/views/dashboard/analytics/index')
  },
  {
    path      : '*/admin/modules',
    name      : 'ViewModules',
    component : portalWrapper,
    props     : {
      view     : 'admin/modules/Modules',
      portalId : 'modules-vue'
    }
  },
  {
    path      : '*/dashboard',
    name      : 'storeDashboard',
    component : () => import('@/views/dashboard/index')
  },
  {
    path      : '*/message',
    name      : 'messages',
    component : portalWrapper,
    props     : {
      view     : 'messages/index',
      portalId : 'messages-list'
    }
  },
  {
    path      : `*/employee/requests*`,
    name      : 'EmployeeRequests',
    component : portalWrapper,
    props     : {
      view     : 'dashboard/panels/RequestGrid',
      portalId : 'employeeRequests'
    }
  },
  {
    path      : `*/employee/costs*`,
    name      : 'EmployeeCosts',
    component : portalWrapper,
    props     : {
      view     : 'user-settings/employee-costs',
      portalId : 'employeeCosts'
    }
  },
  {
    path      : `*/store/requests`,
    name      : 'StoreRequests',
    component : portalWrapper,
    props     : {
      view     : 'dashboard/panels/StoreRequest',
      portalId : 'storeRequest'
    }
  },
  {
    path      : `*/store/positons`,
    name      : 'StorePositions',
    component : portalWrapper,
    props     : {
      view     : 'dashboard/panels/StoreRequest',
      portalId : 'storePosition'
    }
  },
  {
    path      : "*/register/company",
    name      : "companyRegistration",
    component : () => import('@/views/company/register/CompanySignup'),
    meta      : {
      isGuest : true
    }
  },
  {
    path      : "*/site/forgotpassword",
    name      : "ForgotPasswordPage",
    component : () => import('@/views/user/main'),
    meta      : {
      isGuest : true
    }
  },
  {
    path      : "*/site/resetpassword*",
    name      : "RestPassword",
    component : () => import('@/views/user/resetpassword'),
    meta      : {
      isGuest : true
    }
  },
  {
    path      : "*/company/skills",
    name      : "SkillsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/skills",
      portalId  : "skillId",
      namespace : 'skill'
    }
  },
  {
    path      : "*/task/categories",
    name      : "TaskCategoryGrid",
    component : portalWrapper,
    props     : {
      view      : "company/taskCategories",
      portalId  : "taskCategoryId",
      namespace : "taskCategory"
    }
  },
  {
    path      : "*/company/requestaccrualtemplates",
    name      : "RequestAccrualGrid",
    component : portalWrapper,
    props     : {
      view      : "company/requestAccrualTemplates",
      portalId  : "requestAccrualId",
      namespace : 'requestAccrualTemplate'
    }
  },
  {
    path      : "*/company/exemptions",
    name      : "ExemptionsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/exemptions",
      portalId  : "exemptionId",
      namespace : "exemption"
    }
  },
  {
    path      : `*/store/exemptions`,
    name      : 'StoreExemptionsGrid',
    component : portalWrapper,
    props     : {
      view              : 'company/exemptions',
      portalId          : 'exemptionStoreId',
      isStoreExemptions : true,
      namespace         : "exemption"
    }
  },
  {
    path      : "*/company/jobcodes",
    name      : "JobCodesGrid",
    component : portalWrapper,
    props     : {
      view      : "company/jobCodes",
      portalId  : "jobCodeId",
      namespace : 'jobCode'
    }
  },
  {
    path      : "*/company/rules",
    name      : "RuleGrid",
    component : portalWrapper,
    props     : {
      view      : 'company/rules',
      portalId  : 'ruleId',
      namespace : 'rule'
    }
  },
  {
    path      : "*/company/requesttypes",
    name      : "RequestTypesGrid",
    component : portalWrapper,
    props     : {
      view      : "company/requestTypes",
      portalId  : "requestTypeId",
      namespace : 'requestType'
    }
  },
  {
    path      : "*/company/benefits",
    name      : "BenefitsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/benefits",
      portalId  : "benefitId",
      namespace : 'benefit'
    }
  },
  {
    path      : `*/store/benefits`,
    name      : 'StoreBenefitsGrid',
    component : portalWrapper,
    props     : {
      view           : 'company/benefits',
      portalId       : 'benefitStoreId',
      namespace      : 'benefit',
      isStoreBenefit : true
    }
  },
  {
    path      : "*/company/budgets",
    name      : "BudgetsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/budgets",
      portalId  : "budgetId",
      namespace : 'budget'
    }
  },
  {
    path      : "*/company/overtimerules",
    name      : "OvertimeRules",
    component : portalWrapper,
    props     : {
      view      : "company/overtimeRules",
      portalId  : "overtimeRulesId",
      namespace : 'overtimeRules'
    }
  },
  {
    path      : "*/store/budgets*",
    name      : "StoreBudgetsGrid",
    component : portalWrapper,
    props     : {
      view          : "company/budgets",
      portalId      : "budgetStoreId",
      isStoreBudget : true,
      namespace     : 'budget'
    }
  },
  {
    path      : "*/company/departments",
    name      : "DepartmentsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/departments",
      portalId  : "departmentId",
      namespace : 'department'
    }
  },
  {
    path      : "*/chat",
    name      : "ChatApp",
    component : portalWrapper,
    props     : {
      view     : "company/messageApp/index.vue",
      portalId : "chat-view"
    }
  },
  {
    path      : `*/store/departments`,
    name      : 'StoreDepartmentsGrid',
    component : portalWrapper,
    props     : {
      view              : 'company/departments',
      portalId          : 'departmentStoreId',
      isStoreDepartment : true,
      namespace         : 'department'
    }
  },
  {
    path      : "*/company/alerts",
    name      : "AlertsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/alerts",
      portalId  : "alertId",
      namespace : "alert"
    }
  },
  {
    path      : "/employee/related/entity/benefits/id/:userId/entityurl/company/entityid/:companyId",
    name      : "benefits",
    component : portalWrapper,
    props     : {
      view     : "employee/benefits",
      portalId : "benefits"
    }
  },
  {
    path      : "*/signup/verify-email",
    name      : "SignupVerify",
    component : () => import('@/views/onboarding/signup'),
    meta      : {
      isGuest : true
    }
  },
  {
    path      : "*/signup/employeesetup",
    name      : "employeesSetup",
    component : () => import('@/views/onboarding/add-employees')
  },
  {
    path        : "*/company/billing/updatePackage",
    name        : "PackageTableGrid",
    component   : portalWrapper,
    beforeEnter : (to,from,next)=>{
      if(store.getters['billing/isCancelApplied'] || store.getters['billing/isAnniversaryPassed'] || !store.state.app.Company.isActive){       
        return next(false)
      }
      return next()
    },
    props : {
      view     : "billing/updatePackage",
      portalId : "billingId"
    }
  },
  {
    path      : "*/company/billing/",
    name      : "Billing",
    component : portalWrapper,
    props     : {
      view     : "billing/index",
      portalId : "billingId"
    }
  },
  {
    path      : "*/company/stores",
    name      : "StoresGrid",
    component : portalWrapper,
    props     : {
      view      : "company/stores",
      portalId  : "storeId",
      namespace : 'store'
    }
  },
  {
    path      : "*/company/emailtemplates",
    name      : "EmailsTemplateGrid",
    component : portalWrapper,
    props     : {
      view      : "company/emailTemplates",
      portalId  : "emailTemplateId",
      namespace : 'emailTemplate'
    }
  },
  {
    path      : "*/company/positions",
    name      : "PositionsGrid",
    component : portalWrapper,
    props     : {
      view      : "company/positions",
      portalId  : "positionId",
      namespace : 'position'
    }
  },
  {
    path      : "*/store/positions",
    name      : "StorePositionsGrid",
    component : portalWrapper,
    props     : {
      view            : "company/positions",
      portalId        : "positionStoreId",
      isStorePosition : true,
      namespace       : 'position'
    }
  },
  {
    path      : "*/task/company",
    name      : "TaskGrid",
    component : portalWrapper,
    props     : {
      view      : "company/tasks",
      portalId  : "taskId",
      namespace : 'task'
    }
  },
  {
    path      : "*/store/calendarevents",
    name      : "CalendarGrid",
    component : portalWrapper,
    props     : {
      view      : "storeCalendarEvent",
      portalId  : "calendarId",
      namespace : 'calendarEvent'
    }
  },
  {
    path      : "*/task/store",
    name      : "StoreTaskGrid",
    component : portalWrapper,
    props     : {
      view        : "company/tasks",
      portalId    : "storeTaskId",
      isStoreTask : true,
      namespace   : 'task'
    }
  },
  {
    path      : "*/company/availability",
    name      : "CompanyAvailability",
    component : portalWrapper,
    props     : {
      view      : "company/availability",
      portalId  : "availabilityContainerCompany",
      namespace : 'availability'
    }
  },
  {
    path      : "*/task/taskcards",
    name      : "TaskCard",
    component : () => import('@/views/tasks/task-card/index')
  },
  {
    path      : "*/admin/companies",
    name      : "AdminCompany",
    component : portalWrapper,
    props     : {
      view      : "adminpanel",
      portalId  : "admin-companies",
      namespace : 'company'
    }
  },
  {
    path      : "*/admin/stores",
    name      : "AdminStore",
    component : portalWrapper,
    props     : {
      view      : "adminpanel/stores",
      portalId  : "admin-stores",
      namespace : 'adminStore'
    }
  },
  {
    path      : "*/admin/reports",
    name      : "AdminReport",
    component : portalWrapper,
    props     : {
      view     : "admin/reports",
      portalId : "admin-reports"
    }
  },
  {
    path      : "*/admin/users",
    name      : "AdminUser",
    component : portalWrapper,
    props     : {
      view      : "adminpanel/users",
      portalId  : "admin-users",
      namespace : 'adminUser'
    }
  },
  {
    path      : "*/company/modules",
    name      : "ModulesGrid",
    component : portalWrapper,
    props     : {
      view      : "company/modules",
      portalId  : "modulesId",
      namespace : "modules"
    }
  },
  {
    path      : `*/store/modules`,
    name      : 'StoreModulesGrid',
    component : portalWrapper,
    props     : {
      view      : 'company/modules/storeIndex',
      portalId  : 'modulesStoreId',
      namespace : "modules"
    }
  },
  {
    path      : "*/task/scheduled",
    name      : "ScheduledTask",
    component : portalWrapper,
    props     : {
      view      : "tasks/scheduledTask",
      portalId  : "scheduledTasksId",
      namespace : "scheduledTask"
    }
  },
  {
    path      : `*/company/port`,
    name      : 'ImportExport',
    component : portalWrapper,
    props     : {
      view     : 'company/importExport/Index',
      portalId : 'importExport'
    }
  },
  {
    path      : `*/company/integrations`,
    name      : 'StoreMapping',
    component : () => import('@/views/company/integrations/index')
  },
  {
    path      : `*/store/autoscheduling`,
    name      : 'AutoScheduling',
    component : () => import('@/views/autoscheduling/index')
  }
]

routes.push({
  path      : `*/*`,
  name      : 'ChatIcon',
  component : portalWrapper,
  props     : {
    view     : 'company/messageApp/messengerIcon.vue',
    portalId : 'chat-icon'
  }
})

export default routes;